import { ArrowRightOutlined } from '@ant-design/icons';
import { Space, Typography } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FastLinkWrapper } from './style';

function FastLink({ text, path }) {
  const navigate = useNavigate();

  return (
    <FastLinkWrapper>
      <Space align="center" size="small" onClick={() => navigate(path)}>
        <Typography.Link>{text}</Typography.Link>
        <ArrowRightOutlined style={{ color: '#f49b1a' }} />
      </Space>
    </FastLinkWrapper>
  );
}

export { FastLink };
